import {Provider} from '@angular/core';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {AgreementPort} from '@features/agreement/application/ports/agreement.port';
import {AgreementHttpAdapter} from '@features/agreement/infrastructure/http/agreement.http.adapter';

export const AgreementHttpAdapterProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  {
    provide: AgreementPort,
    useClass: AgreementHttpAdapter
  }
];
